<template>
  <div id="data-list-list-view" class="data-list-container">

    <vs-table ref="table" multiple v-model="selected" pagination :max-items="itemsPerPage" search :data="teams">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <!--<vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-5 mb-4">

            <div class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div

            <vs-dropdown-menu>

              <vs-dropdown-item @click.stop="clickDel">
                <span class="flex items-center">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
          -->

          <!-- ADD NEW -->
          <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"  @click="addNewValidation" >
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ teams.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : teams.length }} of {{ queriedItems }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=5">
              <span>5</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

    <template slot-scope="{data}">
      <div id="demo-basic-card">
        <div class="vx-row">

            <div class="vx-col w-full lg:w-1/3 sm:w-1/2 mb-base" :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vx-card class="p-2">

                    <div slot="no-body">
                        <label class="form-checkbox">
    					<!--<input type="checkbox" :value="tr.user_id" v-model="selected">-->
						<i class="form-icon"></i>
  					</label>

                    </div>  

                    <div class="text-center">
                        <h4 v-if="tr.first_name">{{ formatName(tr.first_name) }} {{ formatName(tr.last_name) }}</h4>
                        <h4 v-else>{{ formatName('Invited Guest') }}</h4>
                        <p class="text-grey">{{ tr.email }}</p>

                    </div>
                    <div class="flex justify-between text-center" >
                       <vs-chip transparent color="primary"  class="mx-auto mt-3 role-label">
                            {{ formatName( tr.role_name ) }} 
                        </vs-chip>
                    </div>

                    <vs-avatar class="mx-auto my-6 block" size="80px"  v-if="tr.userImg" :src="tr.userImg" />
                    <vs-avatar class="mx-auto my-6 block" size="80px"  v-else-if="tr.first_name && tr.last_name" v-bind:text="tr.first_name+' '+tr.last_name"/>
                    <vs-avatar class="mx-auto my-6 block" size="80px"  v-else text="Invited Guest"/>
                    
                    <div class="flex justify-between text-center" v-if="tr.user_org_status===1 || tr.user_org_status===0">
                        <span>
                            <p class="text-xl font-semibold">Leads</p>
                            <small class="text-grey" v-if="tr.leads_total">{{ tr.leads_total }}</small>
                            <small class="text-grey" v-else>0</small>
                        </span>
                        <span>
                            <p class="text-xl font-semibold">Sales (RM)</p>
                            <small class="text-grey" v-if="tr.sales_total">{{ tr.sales_total }}</small>
                            <small class="text-grey" v-else>0.00</small>
                        </span>
                        <span>
                            <p class="text-xl font-semibold">Status</p>
                            <vs-switch v-model="tr.user_status" v-if="tr.role_id!==1" @change="toggleUserStatus(tr.user_id, tr.user_status, tr.email)"/>
                             <vs-switch v-model="tr.user_status" v-else disabled="true" else @change="toggleUserStatus(tr.user_id, tr.user_status, tr.email)" />
   
                            
                        </span>
                    </div>
                    <div class="flex justify-between text-center" v-if="(tr.user_org_status===1 || tr.user_org_status===0)">
                        <vs-button class="mt-3 mx-auto shadow-lg primary" v-if="tr.role_id!==1" type="gradient"  @click.stop="editRole(tr.user_id, tr.email, tr.role_id)">Edit Role</vs-button>
                         <vs-button class="mt-3 mx-auto shadow-lg primary" v-if="tr.role_id===1" disabled="true" type="gradient" >Edit Role</vs-button>
                        <!--<vs-button class="mt-3" type="border" color="#b9b9b9">Delete</vs-button>-->
                    </div>
                    <div class="flex justify-between text-center" v-else>
                        <vs-button class="mt-3 mr-2 shadow-lg primary" type="gradient" @click.stop="editRole(tr.user_id, tr.email, tr.role_id)" >Edit</vs-button>
                        <vs-button class="mt-3" type="border" background-color="#b9b9b9" @click.stop="removeUser(tr.user_id, tr.email)">Remove</vs-button>
                    </div>
                    <div class="flex justify-between text-center" v-if="tr.user_org_status===2">
                      <vs-button class="mx-auto mt-3 " type="border" color="#b9b9b9" @click.stop="resendInvitation(tr.email)" >Resend Invitation</vs-button>
                    </div>
                </vx-card>
            </div>

            

        </div>
    </div>


    <vs-prompt
      @cancel="clearValMultiple"
      @accept="addConfirm"
      @close="close"
      :is-valid="validName"
      :active.sync="addNew"
      accept-text="Invite"
      title="Invite Member">
      <div class="quicksend-prompt ">
        Enter your team mate Email and Role to <b>continue</b>.<br/>
        <span>
          <vs-input placeholder="Email" v-model="valMultipe.value1" class="mt-4 mb-2 w-full" />
        </span>
       
        <span>
          <br/>
        <ul class="flex justify-between text-center">
           <span>
        <b>Role : </b>
        </span>
          <li>
            <vs-radio v-model="valMultipe.value2" vs-value="2">Admin</vs-radio>
          </li>
          <li>
            <vs-radio v-model="valMultipe.value2" vs-value="3">Sales</vs-radio>
          </li>
          <li>
            <vs-radio v-model="valMultipe.value2" vs-value="4">Agent</vs-radio>
          </li>
        </ul>
        </span>

       <br/>
      <vs-alert :vs-active="!validName" color="danger" vs-icon="new_releases" >
       Fields can not be empty please enter the email and choose the role
      </vs-alert>
      </div>
    </vs-prompt>

       <vs-prompt
      @cancel="clearValMultiple"
      @accept="editConfirm"
      @close="close"
      :active.sync="editForm"
      accept-text="Update Role"
      title="Edit Team Member Role">
      <div class="quicksend-prompt ">
        You ae only able to edit your <b>team mate role</b>.<br/>
        <span>
          <vs-input placeholder="Email" v-model="valEditForm.value1" disabled="true"  class="mt-4 mb-2 w-full" />
        </span>
       
        <span>
          <br/>
        <ul class="flex justify-between text-center">
           <span>
        <b>Role : </b>
        </span>
          <li>
            <vs-radio v-model="valEditForm.value2" vs-value="2">Admin</vs-radio>
          </li>
          <li>
            <vs-radio v-model="valEditForm.value2" vs-value="3">Sales</vs-radio>
          </li>
          <li>
            <vs-radio v-model="valEditForm.value2" vs-value="4">Agent</vs-radio>
          </li>
        </ul>
        </span>

       <br/>
      </div>
    </vs-prompt>
</template>

   </vs-table>

  


 
 




  </div>

  

</template>


<script>
import router from '@/router';
import axios from '@/axios';


const layoutNames = [ 'Dropdown', 'Grid', 'Card' ];

const dialogs = {
  confirmDelete: (ids, callback) => {
    let text, title;

    if (ids.length > 1) {
      title = `Confirm Deletion of ${ids.length} forms`
      text = `Are you sure you want to delete these ${ids.length} forms?`
    } else {
      title = `Confirm Deletion`
      text = 'Are you sure you want to delete this user?'
    }

    return {
      type: 'confirm',
      color: 'danger',
      title: title,
      text: text,
      accept: callback
    }
  },
  expired: (error) => {
    return {
      color: "danger", 
      title: "Package Expired!",
      text: "Opps, looks like your package already expired, kindly subscribe a new one.",
      accept:() => {
        router.push({name: 'billing-current-plan'})
      },
      close:() => {
        router.push({name: 'billing-current-plan'})
      }
    }
	},
	exceeded: (error) => {
		return {
      color: "danger", 
      title: "Team Limit Exceeded.",
      text: "Opps, your team invitation has reached the limit.",
      accept:() => {
        router.push({name : 'dashboard'})
      },
      close:() => {
        router.push({name : 'dashboard'})
      }
    }
	}
}

export default {
  data () {
    return {
      selected: [],
      itemsPerPage: 5,
      isMounted: false,

      // Data Sidebar
      addNewDataSidebar: false,
      addNew:false,
      valMultipe:{
        value1:'',
        value2:''
      },
      editForm:false,
      valEditForm:{
        value1:'',
        value2:'',
        value3:''
      },
    }
  },



      
    
  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },

    teams () {
        //console.log(JSON.stringify(this.$store.state.team.teams))
      return this.$store.state.team.teams;
    },

    queriedItems () {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.teams.length
    },
     validName(){
      return (this.valMultipe.value1.length > 0 && this.valMultipe.value2.length > 0)
    }
  },
  methods: {
    addNewValidation(){
      if(this.$store.state.user.organizations.find(o => o.organization_id === this.$store.state.organization.current_organization[0].id)  !== null){
			  let current_package_limit = this.$store.state.user.organizations.find(o => o.organization_id === this.$store.state.organization.current_organization[0].id)
			  this.$store.dispatch('subscription/getSubscriptionSummary').then(() => {
          if(!((this.$store.state.subscription.subscription_summary.total_user_quota - this.$store.state.subscription.subscription_summary.total_user_created) > 0)){
            this.$vs.dialog(dialogs.exceeded())
          }else{
            this.addNew = true
          }
			  })
      }else{
        this.$vs.dialog(dialogs.expired())
      }
    },
    formatName(data) {
      if (data) {
        data = data.toString()
        data = data.charAt(0).toUpperCase() + data.slice(1)
        return data;
      }
    },

    formatDate (data) {
      let theDate = new Date(data);
      if (theDate.toString() !== 'Invalid Date' && !_.isEmpty(data)) {
        return theDate.toISOString().slice(0, 19).replace('T', ' ');
      }

      return 'not specified';
    },

    getLayoutName (idxLayout) {
      if (idxLayout < 0 || idxLayout > layoutNames.length + 1) {
        return `invalid layout ${idxLayout}`;
      }
      return layoutNames[idxLayout];
    },

    clickDel() {
      let ids = this.selected.map(x => x.id);
      this.$vs.dialog(dialogs.confirmDelete(ids, () => {
        this.$store.dispatch('team/removeForms', ids).catch(err => { console.error(err) })
      }));
    },

   
    async addConfirm(){

      var params={
        'email': this.valMultipe.value1,
        'role_id': this.valMultipe.value2,
        'user_id': this.$store.state.user.id
      }

      var current_organization=this.$store.state.user.current_organization;

      this.$vs.notify({
        color:'primary',
        title:'Team Member Being Added',
        text:'Please hold on'
      })

       try {
        let res = await axios.post('/organization/'+current_organization+'/invite', params);
      }catch (e) {
        throw e;
      }

      this.$vs.notify({
        color:'success',
        title:'Team Member Added Successfully',
        text:'Invitation Email has been sent to '+this.valMultipe.value1
      })

      this.valMultipe.value1 = "";
      this.valMultipe.value2 = "";

      this.$store.dispatch('team/teamList');
       
    },
    async editRole(user_id, email, role_id)
    {
      
        //alert('fish');
        //return {
          this.valEditForm.value1=email;
          this.valEditForm.value2=role_id;
          this.valEditForm.value3=user_id;
          this.editForm=true;
        //}
    }, 
    async editConfirm(){

      var params={
        'role_id': this.valEditForm.value2,
      }

      var current_organization=this.$store.state.user.current_organization;

      this.$vs.notify({
        color:'primary',
        title:'Team Member Role Being Updated',
        text:'Please hold on'
      })

      console.log(params);

      try {
        let res = await axios.patch('/organization/'+current_organization+'/user/'+this.valEditForm.value3, params);
      }catch (e) {
        throw e;
      }

      this.$vs.notify({
        color:'success',
        title:'Team Member Role Succesffuly Updated',
        //text:'Invitation Email has been sent to '+this.valMultipe.value1
      })

      this.valEditForm.value1 = "";
      this.valEditForm.value2 = "";
      this.valEditForm.value3 = "";

      this.$store.dispatch('team/teamList');
       
    },
    removeUser (id, email) {
      this.$vs.dialog(dialogs.confirmDelete(id, () => {
      var current_organization=this.$store.state.user.current_organization;

      var params={
        'status': '0'
      }

          try {
            let res = axios.patch('/organization/'+current_organization+'/user/'+id, params);
             
             this.$vs.notify({
                color:'success',
                title:'Team Member has been removed Successfully',
                text:'The user with Email of '+email+' has been removed from your organization'
              })

            this.$store.dispatch('team/teamList');

          }catch (e) {
            throw e;
          }

    

      }));
    },

    toggleUserStatus(id, user_status, email) {
      
      this.$vs.dialog(dialogs.confirmDelete(id, () => {
      var current_organization=this.$store.state.user.current_organization;

        var params={
          'status': '0'
        }

         try {
            let res = axios.patch('/organization/'+current_organization+'/user/'+id, params);
             
             this.$vs.notify({
                color:'success',
                title:'Team Member has been removed Successfully',
                text:'The user with Email of '+email+' has been removed from your organization'
              })


          }catch (e) {
            throw e;
          }
          

      }));

      this.$store.dispatch('team/teamList');

    },

    async resendInvitation (email) {
      
      var current_organization=this.$store.state.user.current_organization;

      var params={
        'email': email
      }

          try {
            let res = await axios.post('/organization/'+current_organization+'/resend_invite', params);
             
             this.$vs.notify({
                color:'success',
                title:'Invitation has been resend',
                text:"Invitation has been resend to '"+email+"'. In the case they don't receive it please ask them to check the spam box"
              })

            this.$store.dispatch('team/teamList');

          }catch (e) {
            throw e;
          }

    },

    close(){
      this.$vs.notify({
        color:'danger',
        title:'Closed',
        text:'You close a dialog!'
      })
    },
    clearValMultiple() {
      this.valMultipe.value1 = "";
      this.valMultipe.value2 = "";
    },
     clearValMultiple() {
      this.valEditForm.value1 = "";
      this.valEditForm.value2 = "";
      this.valEditForm.value3 = "";
    }
  },
  created () {
    this.$store.dispatch('team/teamList');
  },
  mounted () {
    this.isMounted = true
  }
}
</script>



<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

   

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
        display: none;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

span.vs-avatar--text.notranslate {
    font-size: 40px;
}

.role-label {
      text-transform: uppercase;
      font-size:15px;
    }
</style>


